import { Injectable } from '@angular/core';

import { Resolve, RouterStateSnapshot } from '@angular/router';

import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { CoursePass } from 'src/app/models/course-pass.model';
import { CourseService } from '../services/course.service';

@Injectable({ providedIn: 'root' })
export class CourseResolver implements Resolve<any> {
  constructor(
    private courseService:CourseService
    ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<CoursePass>|Promise<any>|any {
    let courseId = route.params['id'];
    return this.courseService.checkAvailableCourse(courseId);
  }
}